import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import {
  IMPORT_GET_TOURNAMENT,
  IMPORT_TOURNAMENT,
} from "../../utils/api/ApiConstant";
import { DataTable, SubHeading, Switch } from "../../shared/Components";
import showToast from "../../utils/toastUtil";
import { postAxios } from "../../shared/Services/commonService";

const ImportStep2 = () => {
  const location = useLocation();
  const rowData = location.state;
  const navigate = useNavigate();
  const { source, id } = useParams();
  const [selectedItems, setSelectedItems] = useState({});
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["importTournamentData", , source, id],
    queryFn: async () =>
      await getAxiosImportServer(`${IMPORT_GET_TOURNAMENT}/${source}`, {
        eventType_id: id,
      }),
  });

  const handleSwitchToggle = (row) => {
    setSelectedItems((prev) => ({
      ...prev,
      [row.id]: !prev[row.id],
    }));
  };

  const handleImport = async () => {
    const selectedIds = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map((id) => String(id));

    if (selectedIds.length === 0) {
      showToast.info("Please select at least one item to import");
      return;
    }

    try {
      const response = await postAxios(`${IMPORT_TOURNAMENT}/${source}`, {
        id: selectedIds,
      });

      setSelectedItems({});
      refetch();
    } catch (error) {
      console.error("Import failed", error);
    }
  };

  const fetchData = () => {
    if (!data) return { data: [], pages: 0 };

    return {
      data: data?.data,
      pages: data?.pages,
    };
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue, row }) => {
        return (
          <span
            onClick={() =>
              navigate(`/config/import3/${source}/${row?.original?.id}`, {
                state: {
                  sport: rowData,
                  tournament: row?.original,
                  source: source,
                },
              })
            }
            className="cursor-pointer"
          >
            {getValue()}
          </span>
        );
      },
    },
    {
      accessorKey: "exists",
      header: "Import",
      cell: ({ getValue, row }) => {
        const exists = getValue();
        const isSelected = selectedItems[row.original.id] || false;
        return (
          <Switch
            getValue={() => (exists ? true : isSelected)}
            disabled={exists}
            onChange={() => !exists && handleSwitchToggle(row.original)}
          />
        );
      },
    },
  ];

  return (
    <>
      <SubHeading
        subTitle="Game Import Step-2"
        isAddBtnPage={false}
        isAddBtn={false}
        redirectPath="create"
        isBack={true}
        isImport={true}
        onClick={handleImport}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          // currentPage={currentPage}
          // onPageChange={handlePageChange}
          // onRecordsPerPageChange={handleRecordsperPage}
          // recordsPerPage={recordsPerPage}
          // onSearchChange={handleSearch}
          // searchTerm={searchTerm}
          isLoading={isLoading}
          // handleHeaderSort={handleHeaderSort}
        />
      </div>
    </>
  );
};

export default ImportStep2;
